import axios from "axios";
import { baseUrl } from "../config/app.config";

/**
 * Upload Excel
 * Method : Post
 * POST http://www.ileadnam.com/api/api/Payroll/UploadExemptionDetails
 */

export const UploadPayrollExemptionDetailsExcel = async (model) => {
  let result = { error: false, data: "" };

  try {
    let response = await axios({
      method: "post",
      url: baseUrl + "/api/Payroll/UploadExemptionDetails",
      data: model,
      config: {
        headers: { "Content-Type": "multipart/form-data" },
      },
    });
    result.data = response.data;
  } catch (error) {
    result.error = true;
    result.data = error.response;
  }
  return result;
};
